const COMMON_EMAIL_DOMAIN_TYPOS = {
  'gmai.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gamil.com': 'gmail.com',
  'hotmial.com': 'hotmail.com',
  'outlok.com': 'outlook.com',
};

const fieldKind = (field) => {
  const type = String(field?.type || '').toLowerCase();
  const key = String(field?.key || '').toLowerCase();
  if (type === 'email' || key === 'email') return 'email';
  if (type === 'tel' || type === 'phone' || key === 'tel' || key === 'phone') return 'phone';
  return 'text';
};

export const getLeadFieldError = (field, value, t = (message) => message) => {
  const text = String(value ?? '').trim();
  if (!text) return field?.required ? t('This field is required') : '';

  if (fieldKind(field) === 'email') {
    const email = text.toLowerCase();
    const parts = email.split('@');
    if (!/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(email)
      || parts[0].includes('..') || parts[1].includes('..')) {
      return t('Please enter a valid email');
    }
    const suggestion = COMMON_EMAIL_DOMAIN_TYPOS[parts[1]];
    if (suggestion) return `${t('Check the email domain')}: ${suggestion}?`;
  }

  if (fieldKind(field) === 'phone') {
    const digits = text.replace(/\D/g, '');
    if (!/^\+?[\d\s().-]+$/.test(text) || digits.length < 6 || digits.length > 15) {
      return t('Please enter a valid phone number');
    }
  }

  return '';
};

export const getLeadCreationErrors = (schema = [], values = {}, t) => Object.fromEntries(
  schema.map((field) => [field.key, getLeadFieldError(field, values[field.key], t)])
    .filter(([, error]) => Boolean(error))
);
